import React from "react"
import { Box, Typography, CircularProgress } from "@mui/material";
import Countdown, { zeroPad } from "react-countdown";

export default function MaintenancePage() {

    React.useEffect(() => {
        console.log(process.env.REACT_APP_MAINT)
    },[])


    const renderer = ({days, hours, minutes, seconds, completed }) => (
        <Typography>
           
           Days: {zeroPad(days)} Hours: {zeroPad(hours)} Minutes: {zeroPad(minutes)} Seconds:{zeroPad(seconds)}
        </Typography>
    );


  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        backgroundColor: "#f5f5f5",
      }}
    >
      <Box
        sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            p: 4,
            backgroundColor: "white",
            borderRadius: 4,
            width: "1000px",
            boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
        }}
      >
        {/* <CircularProgress size={64} color="primary" /> */}
        <Box sx={{ display: { xs: 'flex', sm: 'flex', md: 'flex' }}}>
            <img
                src={"/media/undermaint.png"}
                alt="defdelvoto"
                className="align-self-center"
                style={{ width: "938px", height: "188px" }}
            />
        </Box>
        <Typography variant="h5" component="h1" align="center" mt={2}>
          We are improving your experience
        </Typography>
        <Typography variant="body1" align="center" mt={2}>
            Please review more about the Omni Platform here:
        </Typography>
        <Typography variant="body1" align="center" mt={2} component="div">
            <a href="https://omniinteractions.com/faq/" target="_blank" rel="noopener noreferrer">
                https://omniinteractions.com/faq/
            </a>
        </Typography>
      </Box>
    </Box>
  );
}